import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1451.06 557.963C1456.76 557.07 1462.44 556.179 1468.24 556.179C1717.38 556.179 1920 761.2 1920 1013.31C1920 1265.41 1717.38 1470.43 1468.24 1470.43H1355.29V1356.15H1468.24C1655.04 1356.15 1807.06 1202.33 1807.06 1013.31C1807.06 824.283 1655.04 670.46 1468.24 670.46C1467.28 670.46 1466.34 670.632 1465.41 670.803C1464.48 670.975 1463.55 671.146 1462.59 671.146C1463.2 676.832 1463.97 682.485 1464.73 688.143C1466.48 701.135 1468.24 714.146 1468.24 727.601C1468.24 772.4 1462.48 816.855 1451.29 859.825L1342.08 830.569C1350.78 797.084 1355.29 762.571 1355.29 727.601C1355.29 507.038 1177.98 327.616 960 327.616C747.558 327.616 574.871 498.581 566.287 711.373C604.574 730.115 640.602 753.772 671.887 784.628L592.941 866.339C539.746 813.77 469.609 784.742 395.294 784.742C239.661 784.742 112.941 912.852 112.941 1070.45C112.941 1228.04 239.661 1356.15 395.294 1356.15H564.706V1470.43H395.294C177.318 1470.43 0 1291.01 0 1070.45C0 849.883 177.318 670.46 395.294 670.46C416.188 670.46 436.631 673.203 456.847 676.517C482.598 417.098 697.073 213.334 960 213.334C1181.82 213.334 1368.85 358.7 1438.08 559.607C1442.45 559.312 1446.76 558.637 1451.06 557.963ZM717.572 1282.27L637.722 1201.47L960.056 875.31L1282.28 1201.47L1202.43 1282.27L1016.53 1094.16V1813.33H903.586V1094.16L717.572 1282.27Z",
  fillRule: "evenodd"
});

var IconCloudUploadLine = /*#__PURE__*/function (_Component) {
  _inherits(IconCloudUploadLine, _Component);

  var _super = _createSuper(IconCloudUploadLine);

  function IconCloudUploadLine() {
    _classCallCheck(this, IconCloudUploadLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconCloudUploadLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconCloudUpload",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconCloudUploadLine.displayName = "IconCloudUploadLine";
  return IconCloudUploadLine;
}(Component);

IconCloudUploadLine.glyphName = 'cloud-upload';
IconCloudUploadLine.variant = 'Line';
IconCloudUploadLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconCloudUploadLine;
export { IconCloudUploadLine };